<template>
  <div id="historico-mosia-chat">
    <div class="conversas">
      <div class="container-conversas" v-if="conversas.length > 0">
        <template v-for="conversa in conversas">
          <div
          :key="conversa.msg_id"
          class="conversa"
          :class="originNameClass(conversa.origin)"
          >
          <el-row class="conversa-info">
              <span v-if="conversa.origin==='system'"><i class="material-icons-outlined">smart_toy</i></span>
              <span v-else>{{originName(conversa.origin)}}</span>
              <span v-if="conversa.origin==='caller'" class="capitalize">{{nomeUsarioLowercase}}</span>
              <span v-else class="capitalize">{{conversa.from.toLowerCase()}}</span>
              <span>{{conversa.timestamp | dateBr}} - {{conversa.timestamp | timeBr}}</span>
          </el-row>
          <div
            v-if="conversa.type !== 'file'"
            class="mensagem"
            :data-v-origin="originNameClass(conversa.origin)"
            :class="originNameClass(conversa.origin)"
          >
            <p>{{conversa.data.message}}</p>
          </div>
          <div
            v-if="conversa.type === 'file'"
            class="arquivos"
            :data-v-origin="originNameClass(conversa.origin)"
            :class="originNameClass(conversa.origin)"
          >
            <div class="arquivo">
              <div class="file-name">
                <img class="img-prev" v-if="isImage(conversa.data.ext)" :src="conversa.data.url"/>
                <span v-else><i class="icon-prev el-icon-document"></i> </span>
                <p>{{conversa.data.name}}</p>
              </div>
              <div>
                <span class="file-size">{{conversa.data.size}}</span>
                <el-button type="text" @click="downloadS3Signed(conversa.data)">ABRIR</el-button>
              </div>
            </div>
          </div>
        </div>
        </template>
      </div>
      <div v-else class="text-center empty-data">
        <h4>Não há conversas</h4>
        <p>No momento não há nenhuma conversa registrada</p>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex'
import { MosiaChatResource } from '@/API'
import moment from 'moment'
import { forceDownloadURL } from '@/utils/Download'

const enumOrigin = {
  'agent': 'Atendente',
  'system': 'Mensagem Automática',
  'caller': 'Chamador'
}
export default {
  name: 'HistoricoChat',
  components: {
  },
  data () {
    return {
      conversas: []
    }
  },
  props: {
    numeroProtocolo: {}
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao']),
    ...mapGetters('Login', ['nomeUsuario']),
    ...mapState('SetupApp', ['funcionalidade', 'apiOcorrenciaPublico']),
    nomeUsarioLowercase () {
      return this.nomeUsuario ? this.nomeUsuario.toLowerCase() : ''
    },
    originNameClass () {
      return (origin) => {
        if (origin === 'caller') {
          return 'is-caller'
        }
        if (origin === 'agent') {
          return 'is-agent'
        }
        if (origin === 'system') {
          return 'is-system'
        }
      }
    }
  },
  filters: {
    sizeFilter (value) {
      let formated = value
      let suffix = 'b'

      if (formated > 1024) {
        formated = (formated / 1024).toFixed(3)
        suffix = 'Kb'

        if (formated > 1024) {
          formated = (formated / 1024).toFixed(3)
          suffix = 'Mb'
        }

        if (formated > 1024) {
          formated = (formated / 1024).toFixed(3)
          suffix = 'Gb'
        }
      }

      return `${formated} ${suffix}`
    },
    dateBr (value) {
      return moment(value, 'x').format('DD/MM/YYYY')
    },
    timeBr (value) {
      return moment(value, 'x').format('HH:mm')
    }
  },
  methods: {
    async init () {
      await this.getConversas()
    },
    async getConversas () {
      const response = await MosiaChatResource.historicoConversa(this.numeroProtocolo)
      if (response.data.messages) {
        this.conversas = response.data.messages
      }
    },
    isImage (arquivo) {
      return arquivo.includes('JPG', 'PNG', 'JPEG', 'GIF', 'SVG')
    },
    async downloadS3Signed (data) {
      const jsonData = {
        bucket: data.bucket,
        tempoExpiracaoS: 900,
        forcaDownload: true,
        data: [
          {
            key: data.fileKey
          }
        ]
      }
      const urlSigned = await MosiaChatResource.assinarUrlDownload(jsonData)

      forceDownloadURL({ nome: data.name, url: urlSigned.data[0].url })
    },
    originName (_enum) {
      return enumOrigin[_enum]
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
.conversas {
  box-sizing: border-box;
  overflow-y: scroll;
  width: 100%;
  min-height: 400px;
  max-height: 1000px;

  .container-conversas{
    padding-top: 5px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .conversa {
    padding: 0 5px 15px 0px;
    position: relative;
    width: 83%;

    .conversa-info {
      font: 12px Arial;
      margin: 0 0 5px;
      color: #888888;

      span {
        display: inline-block;
        margin-right: 15px;

        &:nth-child(1n+2)::before {
          content: '|';
          margin-right: 15px;
        }
      }
    }
    .material-icons-outlined {
      font-size: 13px;
      vertical-align: bottom;
    }
    .conversa-info-interno {
      font: 12px Arial;
      margin: 0 0 5px;
      color: #888888;

      span {
        display: inline-block;
        margin-right: 0 !important;
      }
    }
    .mensagem {
      padding: 10px 15px;
      border-radius: 6px;
      font: 14px Arial;
      color: #333333;
      word-break: break-all;
      white-space: pre-line;
      margin: 0;
    }
    .arquivos {
      padding: 10px 15px;
      border-radius: 6px;

      p {
        white-space: pre-line;
        color: #333333;
        font: 14px Arial;
        margin: 0 0 10px;
      }
      .arquivo {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .file-name {
          display: flex;
          align-items: center;
          font: 11px Arial;
          color: #333333;

          .img-prev {
            width: 20px;
            margin-right: 10px;
            height: 20px;
          }
          .icon-prev {
            font-size: 20px;
            margin-right: 10px;
            line-height: 20px;
          }
          > p {
            margin: 0;
          }
        }
        .file-size {
          font: 11px Arial;
          color: #888888;
          margin-right: 15px;
        }
        .el-button {
          font: bold 11px Arial;
          margin: 0 15px 0 0;
        }
      }
    }
    .mensagem[data-v-origin="is-caller"], .arquivos[data-v-origin="is-caller"] {
      background-color: #E1ECF8;
    }

    .mensagem[data-v-origin="is-agent"], .arquivos[data-v-origin="is-agent"] {
      background-color: #FFFFFF;
      border: 1px solid #BBCCE0;
    }
    .mensagem[data-v-origin="is-system"], .arquivos[data-v-origin="is-system"] {
      background-color: #F6F6F6;
    }
  }
}
.empty-data{
  padding-top:110px;

  .h4{
    color: #999999;
    font-size:16px;
  }
  .p{
    font-size:14px;
    color: #999999;
  }
}
.is-caller {
  place-self: flex-end;
}
.capitalize {
  text-transform: capitalize;
}

/* Scrollbar */
* {
  scrollbar-width: auto;
  scrollbar-color: #b5b5b5 #ffffff;
}
*::-webkit-scrollbar {
  width: 5px;
}
*::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0);
}
*::-webkit-scrollbar-thumb {
  background-color: #b5b5b5;
  border-radius: 10px;
  border: 1px solid #ffffff;
}
</style>
